import globalFnFactory from 'components/globalFn/globalFnFactory'
import Sale from './Sale'
import Customer from './Customer'
import Goods from './Goods'
import Ukey from './Ukey'
import {
    toFixed,
} from '../invoiceUtils'

const globalFn = globalFnFactory()
export default class Invoice {
    constructor(invoice) {
        this.sale = new Sale(invoice)
        this.details = []
        this.step = 50
        this.min = -1
        this.max = this.step
        if (invoice) {
            this.customer = new Customer().fromInvoice(invoice)
            this.ukey = new Ukey().formInvoice(invoice)
            Object.assign(this, invoice)
            this.remark = invoice.remark || invoice.invoiceRemark
            const details = invoice.waitDetailList || invoice.invoiceDetailList || invoice.detail
            if(details&&details.length>this.step&&details.length<this.step+11){
                this.max=details.length
            }
            const isRed = this.isRed === '1'
            const isBill = this.isBill ? true : false
            if (details) {
                // details.forEach((detail) => {
                //     const goods = new Goods().fromInvoiceDetail(detail, this.invType)
                //     goods.isRed = isRed
                //     goods.isTax = this.isTax
                //     this.details.push(goods)
                // })
                for (let i = 0; i < details.length; i++) {
                    const goods = new Goods().fromInvoiceDetail(details[i], this.invType)
                    goods.isRed = isRed
                    goods.isBill = isBill
                    goods.isTax = this.isTax
                    this.details.push(goods)
                }
            }
            return
        }
        this.customer = new Customer()
        const ukey = new Ukey()
        this.ukey = ukey.fromUkey(ukey.ukeyList[0])
        // 默认值设置为待开蓝票的值
        this.invoiceSource = '1'
        this.tenantId = 0 // 租户ID
        this.busSysId = 0 // 业务系统ID
        this.projectId = 0 // 项目
        this.isInvoice = '0' // 是否开票,0(未开);1(已开);2(重开) ,
        this.isList = '0' // 清单标志 默认非清单
        this.isRed = '0' // 默认蓝票
        this.details = [new Goods()]
        this.adValoremTotal = 0
        this.$isTax = '1' // 默认含税
        this.totalAmt = 0
        this.totalTaxamt = 0
        this.adValoremTotal = 0
        this.remark = ''
        this.ovatInvoiceExtend = {}
    }

    // 只读属性
    get isTaxText() {
        if (this.isTax === '1') {
            return '含税'
        }
        return '不含税'
    }

    get chineseTotal() {
        if (this.isEditPage) {
            return globalFn.digitUppercase(this.adValoremTotal)
        }
        return globalFn.digitUppercase(this.$adValoremTotal)
    }

    get $totalAmt() {
        let totalAmt = 0
        this.details.forEach((detail) => {
            totalAmt = globalFn.Add(totalAmt, detail.amount)
        })
        return totalAmt
    }

    get $totalTaxamt() {
        let totalTaxamt = 0
        this.details.forEach((detail) => {
            totalTaxamt = globalFn.Add(totalTaxamt, detail.taxAmount)
        })
        return totalTaxamt
    }

    get $adValoremTotal() {
        return parseFloat(globalFn.Add(this.$totalTaxamt, this.$totalAmt)).toFixed(2)
    }

    /**
     * 转换为数据传输对象前端为方便管理将发票拆分成
     * @return {Object} 后台需要的数据结构
     */
    toWaitDTO() {
        const waitDto = {
            ...this,
            ...this.customer,
            ...this.sale,
            ...this.ukey,
        }
        delete waitDto.customer
        delete waitDto.sale
        delete waitDto.details
        delete waitDto.ukey
        waitDto.quota = this.ukey.quotas[this.invType]
        waitDto.totalAmt = this.$totalAmt
        if (this.details.length > 0) {
            waitDto.taxRate = this.details[0].taxRate
            waitDto.matName = this.details[0].matName
            // 是否多税率
            const newArr = Array.from(new Set(this.details.map((detail) => detail.taxRate)))
            if (newArr.length > 1) {
                waitDto.taxRate = ''
            }
        }
        waitDto.totalTaxamt = this.$totalTaxamt
        waitDto.adValoremTotal = this.$adValoremTotal
        if (this.isEditPage) {
            waitDto.totalAmt = this.totalAmt
            waitDto.totalTaxamt = this.totalTaxamt
            waitDto.adValoremTotal = this.adValoremTotal
        }
        waitDto.waitDetailList = this.details
        return waitDto
    }

    get $isTax() {
        return this.isTax
    }

    set $isTax(isTax) {
        this.isTax = isTax
        this.details.forEach((goods) => {
            goods.isTax = isTax
        })
    }

    set $isRed(isRed) {
        this.isRed = isRed
        this.remark = '对应正数发票代码:            号码:'
        this.details.forEach((goods) => {
            goods.isRed = isRed === '1'
        })
    }

    addGoods(call) {
        const goods = new Goods()
        goods.isRed = this.isRed === '1'
        goods.isTax = this.isTax
        goods.serialNo = this.details.length + 1
        this.details.push(goods)
        call && call()
    }

    get invTypeName() {
        const map = {
            0: '增值税专用发票',
            2: '增值税普通发票',
            51: '增值税电子普通发票',
            14: '通行费电子发票',
        }
        return map[this.invType]
    }

    fromBlue(blueInvoice) {
        this.customer = new Customer().fromInvoice(blueInvoice)
        // this.ukey = new Ukey().formInvoice(invoice)
        // Object.assign(this, blueInvoice)
        this.isRed = '1'
        const details = blueInvoice.waitDetailList || blueInvoice.invoiceDetailList
        this.billCode = blueInvoice.billCode
        this.blueInvoiceCode = blueInvoice.invoiceCode
        this.blueInvoiceNumber = blueInvoice.invoiceNumber
        this.redAmount = blueInvoice.redAmount
        this.blueInvoiceId = blueInvoice.invoiceId
        this.redTax = blueInvoice.redTax
        this.isList = blueInvoice.isList
        this.extendInfo = blueInvoice.extendInfo
        if (!details) {
            return
        }
        const newDetails = []
        // this.ukey.payee = blueInvoice.payee
        let invoiceCodeLabel = '对应正数发票代码'
        let invoiceNumberLabel = '号码'
        if (blueInvoice.isRed === '1' && (blueInvoice.redApplicant === '0' || blueInvoice.redApplicant === '2')) {
            invoiceCodeLabel = '对应蓝字专用发票代码'
        }
        if (blueInvoice.isRed === '1' && blueInvoice.redApplicant === '1') {
            this.remark = ''
        } else {
            this.remark = `${invoiceCodeLabel}:${blueInvoice.invoiceCode}${invoiceNumberLabel}:${blueInvoice.invoiceNumber}`
        }
        if (details[0].balance) {
            details[0].balance = -details[0].balance
            this.remark = `差额征税。${this.remark}`
        }

        let totalAmt = 0
        let totalTaxamt = 0
        // 首相合并折扣行 发所有商品行转为红票商品行
        details.forEach((blueDetail, index) => {
            // blueDetail: 蓝票商品行
            // redDetail: 转换后的红票商品行
            // discountDetail :折扣商品行
            if (blueDetail.lineNature === '1') {
                return
            }
            const redDetail = new Goods().fromInvoiceDetail(blueDetail, this.invType)
            redDetail.isRed = true
            const discountDetail = details[index + 1]
            if (discountDetail && discountDetail.lineNature === '1' && discountDetail.taxAmount + blueDetail.taxAmount == 0) return
            if (blueDetail.quantity && blueDetail.quantity > 0) {
                redDetail.quantity = -blueDetail.quantity
            } else {
                redDetail.quantity = ''
            }
            // 合并折扣行
            if (discountDetail && discountDetail.lineNature === '1') {
                redDetail.amount = -globalFn.Add(blueDetail.amount, discountDetail.amount)
                redDetail.adValoremTotal = -globalFn.Add(blueDetail.adValoremTotal, discountDetail.adValoremTotal)
                if (redDetail.quantity) {
                    redDetail.price = globalFn.Div(redDetail.amount, redDetail.quantity)
                    redDetail.taxPrice = globalFn.Div(redDetail.adValoremTotal, redDetail.quantity)
                }
            } else {
                redDetail.amount = -blueDetail.amount
                redDetail.adValoremTotal = -blueDetail.adValoremTotal
            }
            redDetail.taxAmount = globalFn.Sub(redDetail.adValoremTotal, redDetail.amount)

            totalAmt = globalFn.Add(totalAmt, redDetail.amount)
            totalTaxamt = globalFn.Add(totalTaxamt, redDetail.taxAmount)
            redDetail.serialNo = newDetails.length + 1
            redDetail.isTax = this.isTax
            newDetails.push(redDetail)
        })
        this.details = newDetails
        this.totalAmt = totalAmt
        this.adValoremTotal = parseFloat(globalFn.Add(totalTaxamt, totalAmt)).toFixed(2)
        this.totalTaxamt = totalTaxamt
        // 清单发票按税率合并，商品名称以第一行商品
        if (blueInvoice.isList === '1') {
            const rateArr = newDetails.map((item) => item.taxRate)
            const newRateArr = Array.from(new Set(rateArr))
            const newWaitArr = newRateArr.slice()
            const newRateArrLth = newRateArr.length
            if (this.invType == 51) {
                if (newRateArrLth > 0) {
                    for (let a = 0; a < newRateArrLth; a++) {
                        let first = true
                        for (let i = 0, l = newDetails.length; i < l; i++) {
                            if (newDetails[i].taxRate === newRateArr[a]) {
                                if (first) {
                                    first = false
                                    newWaitArr[a] = newDetails[i]
                                    newWaitArr[a].quantity = ''
                                    newWaitArr[a].price = ''
                                    newWaitArr[a].taxPrice = ''
                                } else {
                                    newWaitArr[a].amount = toFixed(globalFn.Add(newWaitArr[a].amount, newDetails[i].amount), 2)
                                    newWaitArr[a].adValoremTotal = toFixed(globalFn.Add(newWaitArr[a].adValoremTotal, newDetails[i].adValoremTotal), 2)
                                    newWaitArr[a].taxAmount = toFixed(globalFn.Add(newWaitArr[a].taxAmount, newDetails[i].taxAmount), 2)
                                }
                            }
                        }
                    }
                    // 重新赋值
                    this.details = newWaitArr
                }

            } else {
                this.details = [$.extend(new Goods(), {
                    quantity: '',
                    price: '',
                    taxPrice: '',
                    adValoremTotal: 0 - blueInvoice.adValoremTotal,
                    taxAmount: 0 - blueInvoice.totalTaxamt,
                    amount: 0 - blueInvoice.totalAmt,
                    shortAndMatName: '详见对应正数发票及清单',
                    matName: '详见对应正数发票及清单',
                    serialNo: 1,
                    lineNature: '0',
                    privilegeType: '0',
                    isPrivilege: '0',
                    // taxRateArr: [{
                    //     isPrivilege: '0',
                    //     privilegeType: '0',
                    //     taxRate: 10.02,
                    //     taxText: 10.02
                    // }],
                    zeroTax: '',
                    isTax: '1',
                    taxRate: 10.02,
                    isRed: true
                })]

                if (newRateArrLth == 1) {
                    this.details[0].taxRateArr = [{
                        isPrivilege: '0',
                        privilegeType: '0',
                        taxRate: newRateArr[0],
                        taxText: newRateArr[0] ? `${newRateArr[0] * 100}%` : newRateArr[0]
                    }]
                    this.details[0].taxRate = newRateArr[0]
                }
            }
        }
    }

    getMaxRow() {
        let maxRow = 8
        if (this.sale.isChineseSecurity === '1') {
            maxRow = 7
        }
        return maxRow
    }

    redToRed(redInvoice) {
        this.customer = new Customer().fromInvoice(redInvoice)
        this.isRed = '1'
        const details = redInvoice.waitDetailList || redInvoice.invoiceDetailList
        this.blueInvoiceCode = redInvoice.blueInvoiceCode
        this.blueInvoiceNumber = redInvoice.blueInvoiceNumber
        this.redAmount = redInvoice.redAmount
        this.blueInvoiceId = redInvoice.blueInvoiceId
        this.redTax = redInvoice.redTax
        this.isList = redInvoice.isList
        if (!details) {
            return
        }
        const newDetails = []
        // 首相合并折扣行 发所有商品行转为红票商品行
        details.forEach((blueDetail, index) => {
            // blueDetail: 蓝票商品行
            // redDetail: 转换后的红票商品行 
            if (blueDetail.lineNature === '1') {
                return
            }
            const redDetail = new Goods().fromInvoiceDetail(blueDetail, this.invType)
            redDetail.isRed = true
            newDetails.push(redDetail)
        })
        this.details = newDetails
        this.ukey.payee = redInvoice.payee
        this.remark = redInvoice.remark

        let totalAmt = redInvoice.totalAmt
        let totalTaxamt = redInvoice.totalTaxamt
        this.totalAmt = totalAmt
        this.adValoremTotal = redInvoice.adValoremTotal
        this.totalTaxamt = totalTaxamt
    }
}


// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/invoice1/model/Invoice.js